export const date = {
    days: 'day',
    months: 'month',
    years: 'year',
    minutes: 'minute',
    minutes_short: 'min',
    hours: 'hour',
    hours_short: 'hr',
    date_flase: 'Please select your birthday.',
    month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    month_full_arr: [
        { strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }
    ]
}